import { ProgramWeekEnum } from 'src/modules/programs/models/programs';

export enum CPProgramSharedStep {
    CorePillarsCheckInStep = 'core-pillars-check-in',
    MindfulnessTipsStep = 'mindfulness-tips',
}

export type CorePillarsRating = Record<ProgramWeekEnum, number>;

export interface CorePillarsRatingRequestData {
    mindfulness: number;
    values: number;
    action: number;
    flexibility: number;
}

export interface ChangeCorePillarsRatingActionArguments {
    weekId: ProgramWeekEnum;
    value: number;
}
